//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    searchable: {
      type: Boolean,
      default: false
    },
    selectLabel: {
      type: String,
      default: ''
    },
    deselectLabel: {
      type: String,
      default: ''
    },
    deselectGroupLabel: {
      type: String,
      default: ''
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    tagPosition: {
      type: String,
      default: 'bottom'
    },
    type: {
      type: String,
      default: ''
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    // Чуть изменил, что бы можно было свой селект прокинуть
    eventsListeners() {
      const select = (event) => {
        const query = {...this.$route.query}
        delete query.search
        delete query.pageNum
        if (event.id === 'all') {
          delete query[this.type]
        } else {
          query[this.type] = event.id
        }
        if (query.ignoreBanner) {
          delete query.ignoreBanner
        }
        this.$router.push({
          path: this.$route.path,
          query
        })
        // this.$emit('select', event.target.value)
      }
      const remove = (event) => {
        const query = {...this.$route.query}
        delete query[this.type]
        delete query.pageNum
        this.$router.push({
          path: this.$route.path,
          query
        })
      }
      const config = {
        ...this.$listeners,
        select: this.$listeners.select || select,
        remove: this.$listeners.remove || remove
      }

      return config
    }
  }
}
